import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import { Col, Spinner } from "react-bootstrap";
import { COUNTRY_CODES } from "../../../../constants/countryCodes";
import "./CreateUser.css";

export default function CreateBaseUser({ show, closeModal, refreshPage }) {
  const [validationError, setValidationError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [toggle, setToggle] = useState(false);
  const countryCodes = COUNTRY_CODES;

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    country_code: "+234", // Default to USA
    status: "",
    password: "",
  });

  const resetForm = () => {
    setFormData({
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      country_code: "+234", 
      status: "",
      password: "",
    });
    setValidationError({});
  };

  const handleToggle = () => {
    setToggle(!toggle);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      // Allow only numbers for phone
      const numericValue = value.replace(/[^0-9]/g, "");
      setFormData((prev) => ({ ...prev, phone: numericValue }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // Combine country code and phone number for submission
      const payload = {
        ...formData,
        phone: `${formData.country_code}${formData.phone}`,
      };

      await axiosInstance.post("/user/base_user/add_base_user", payload);
      handleClose();
      refreshPage();
      toast.success("Base user created successfully!");
    } catch (error) {
      console.error("Error submitting form:", error);
      if (error.response && error.response.data.errors) {
        setValidationError(error.response.data.errors);
      }
      toast.error(
        error.response?.data?.message ||
          "An error occurred while creating the user."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    resetForm();
    closeModal();
  };

  return (
    <div className="CreateUser">
      <Modal show={show} onHide={handleClose}>
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add User Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="formFirstName">
              <div>
                <h6>First Name</h6>
              </div>
              <Form.Control
                type="text"
                placeholder="Enter..."
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                required
              />
              {validationError.first_name && (
                <small className="text-danger my-1">
                  {validationError.first_name[0]}
                </small>
              )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formLastName">
              <div>
                <h6>Last Name</h6>
              </div>
              <Form.Control
                type="text"
                placeholder="Enter..."
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                required
              />
              {validationError.last_name && (
                <small className="text-danger my-1">
                  {validationError.last_name[0]}
                </small>
              )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formEmail">
              <div>
                <h6>Email</h6>
              </div>
              <Form.Control
                type="email"
                placeholder="Enter..."
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              {validationError.email && (
                <small className="text-danger my-1">
                  {validationError.email[0]}
                </small>
              )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formPhone">
              <div>
                <h6>Phone</h6>
              </div>
              <div className="input-group">
                <select
                  name="country_code"
                  value={formData.country_code}
                  onChange={handleChange}
                  className="form-control"
                  style={{ width: "5%" }}
                >
                  {countryCodes.length === 0 ? (
                    <option>Loading...</option>
                  ) : (
                    countryCodes.map((country) => (
                      <option key={country.code} value={country.code}>
                        {country.label}
                      </option>
                    ))
                  )}
                </select>
                <Form.Control
                  type="tel"
                  placeholder="Enter phone number..."
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="form-control"
                  style={{ width: "60%" }}
                />
              </div>
              {validationError.phone && (
                <small className="text-danger my-1">
                  {validationError.phone[0]}
                </small>
              )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formStatus">
              <div>
                <h6>Status</h6>
              </div>
              <Form.Select
                name="status"
                value={formData.status}
                onChange={handleChange}
                required
              >
                <option value="">-- Select Status --</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </Form.Select>
              {validationError.status && (
                <small className="text-danger my-1">
                  {validationError.status[0]}
                </small>
              )}
            </Form.Group>

            <Col md={12} lg={12} xs={12} sm={12} className="mb-2">
              <div className="position-relative auth-pass-inputgroup">
                <Form.Label>Create Password</Form.Label>
                <input
                  type={toggle ? "text" : "password"}
                  className="form-control pe-5 password-input"
                  placeholder="Enter password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <button
                  className="btn btn-link position-absolute end-0 text-decoration-none text-muted password-addon"
                  style={{ top: "30px" }}
                  type="button"
                  onClick={handleToggle}
                >
                  <i
                    className={`${toggle ? "ri-eye-off-fill" : "ri-eye-fill"} align-middle`}
                  ></i>
                </button>
                {validationError.password && (
                  <small className="text-danger my-1">
                    {validationError.password[0]}
                  </small>
                )}
              </div>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button
              style={{ backgroundColor: "#c4281b", color: "#fff" }}
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  Saving...
                </>
              ) : (
                "Save"
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}